import { termsAndConditionsLinks } from "@/modules/application/common/constants";
import { LanguageKey, type LanguageValue, Storage } from "@/shared/common/enums";
import { getFromLocalStorage } from "@/shared/helpers";
import { Link } from "@ab.uitools/ui-library/components/Link";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

export const ApplicationTermsAndConditionsLink = () => {
  const { t } = useTranslation();
  const lang = (getFromLocalStorage(Storage.Lang) ||
    LanguageKey.Hy) as keyof typeof LanguageValue;

  const termsAndConditionsLink = termsAndConditionsLinks[lang as keyof typeof termsAndConditionsLinks];

  const onOpenTermsAndConditions = () => {
    window.open(termsAndConditionsLink, "_blank", "noopener,noreferrer");
  };
  return (
    <span className="flexbox">
      <Text className="pr-4">{t("general.agree")}</Text>
      <Link onclick={onOpenTermsAndConditions}>{t("general.conditions")}</Link>
    </span>
  );
};
